export default "__VITE_ASSET__Blr5r9Mp__"